// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JM9GV","subTitle":"styles_subTitle__fReGC","category_back":"styles_category_back__W7e-b"};